import React from 'react';
import { Redirect, Route } from 'react-router-dom';
// import matchPropTypes from "./matchPropTypes";

/**
 * If we have a logged-in user, redirect to the home page. Otherwise, display the component.
 */
const PublicRoute = ({ component: Component, user, ...rest }) => {
  let redirectPath = '/error/404';
  if (user && rest.path !== '*') {
    const isLoginUserClient = user.users3 && user.users3.userRoles.roleName.toUpperCase() === 'CLIENT';
    const isLoginUserSuperAdmin = user && user.roleName && (user.roleName.toUpperCase() === 'SUPERADMIN' || user.roleName.toUpperCase() === 'SUPERUSER');

    if (!isLoginUserClient && !isLoginUserSuperAdmin) {
      redirectPath = '/dashboard';
    } else if (isLoginUserClient) {
      //redirectPath = '/client-dashboard';
      redirectPath = '/my-profile';
    }
    else if (isLoginUserSuperAdmin) {
      redirectPath = '/webadmin/dashboard';
    }
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        user
          ? <Redirect to={{ pathname: redirectPath }} />
          : <Component user={user} {...props} />}
    />
  )
}

// PublicRoute.propTypes = matchPropTypes;

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/routers/PublicRoute.js